import {webChannexConstants} from "../../../../constants/Web/webChannex.constants";

const initialState = {
    fetching: false,
    status: null,
    error: false,

    connectFetching: false,
    connectData: null,
    connectError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case webChannexConstants.WEB_CHANNEX_STATUS_PENDING:
            return {...state, fetching: true, error: false};
        case webChannexConstants.WEB_CHANNEX_STATUS_FULFILLED:
            return {
                ...state,
                fetching: false,
                error: false,
                status: (action.payload && action.payload.data) || null,
            };
        case webChannexConstants.WEB_CHANNEX_STATUS_REJECTED:
            return {...state, fetching: false, error: action.payload};

        case webChannexConstants.WEB_CHANNEX_CONNECT_PENDING:
            return {...state, connectFetching: true, connectData: null, connectError: false};
        case webChannexConstants.WEB_CHANNEX_CONNECT_FULFILLED:
            return {
                ...state,
                connectFetching: false,
                connectError: false,
                connectData: action.payload,
                // Servis guncel durumu donuyorsa yereldeki kopyayi tazele
                status: (action.payload && action.payload.data) || state.status,
            };
        case webChannexConstants.WEB_CHANNEX_CONNECT_REJECTED:
            return {...state, connectFetching: false, connectError: action.payload};

        case webChannexConstants.WEB_CHANNEX_CLEAR:
            return {...state, connectData: null, connectError: false};

        default:
            return state;
    }
}
